import { baseImgPath } from '@/config/env';
import defaultImg from '@/assets/xuqiu.png'
export function imageUrl(url) {
    if (typeof(url) == 'undefined' || url == '') {
        return ''
    } else if (url.startsWith('http')) {
        return url
    } else {
        return baseImgPath + url
    }
}

export function headUrl(url) {
    let head = imageUrl(url)
    if (head == '')
        return defaultImg
    return head
}


// WEBPACK FOOTER //
// ./src/utils/imageUrl.js